import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { fetchRecommendedJobs } from "../../../behavior/api/viewer";
import type { JobPosting } from "../../../types/jobPosting";
import { Heading, HorizontalLine } from "../../elements";
import JobPostingsList from "./JobPostingsList";

const Header = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="title-section">
                <Heading level="h5">{t("Dashboard.LatestJobPostings.Title")}</Heading>
            </div>
            <HorizontalLine className="mb-5" weight="semi-dark" />
            <Heading level="h4" light>
                {t("Dashboard.LatestJobPostings.Subtitle")}
            </Heading>
        </>
    );
};

const LatestJobPostings = () => {
    const PAGE_SIZE = 20;

    const {
        isLoading: loading,
        error,
        data: recommendedJobs,
    } = useQuery<JobPosting[]>({
        queryKey: ["recommendedJobs", PAGE_SIZE],
        queryFn: () => fetchRecommendedJobs(PAGE_SIZE),
    });

    const hasRecommendations = !!recommendedJobs?.length;
    if (loading || !hasRecommendations) return <></>;

    return (
        <div className="latest-job-postings-wrapper">
            <Header />
            <JobPostingsList loading={loading} error={error} jobPostings={recommendedJobs} />
        </div>
    );
};

export default LatestJobPostings;
